import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Table, Spinner } from "react-bootstrap";
import axios from "axios";

const CITasksData = () => {
  const [clients, setClients] = useState([]);
  const [sites, setSites] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedSite, setSelectedSite] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch clients
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/ci/clients`)
      .then(res => {
        console.log("Fetched clients:", res.data); // 👈 log the full response
        setClients(res.data.clients);
      })
      .catch(err => console.error("Error fetching clients:", err));
  }, []);

  // Fetch sites when client changes
  useEffect(() => {
    if (selectedClient) {
      axios.get(`/api/ci/clients/${selectedClient}/sites`)
        .then(res => {
            console.log("Fetched sites:", res.data);
            setSites(res.data.sites)
        })
        .catch(err => console.error("Error fetching sites:", err));
    } else {
      setSites([]);
      setSelectedSite("");
    }
  }, [selectedClient]);

  // Fetch tasks when site changes
  useEffect(() => {
    if (selectedSite) {
      setLoading(true);
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/ci/sites/${selectedSite}/tasks`)
        .then(res => {
          console.log(res.data);
          setTasks(res.data.tasks);
          setLoading(false);
        })
        .catch(err => {
          console.error("Error fetching tasks:", err);
          setLoading(false);
        });
    } else {
      setTasks([]);
    }
  }, [selectedSite]);

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Select Client</Form.Label>
            <Form.Select
              value={selectedClient}
              onChange={(e) => setSelectedClient(e.target.value)}
            >
              <option value="">-- Select Client --</option>
              {clients.map(client => (
                <option key={client.id} value={client.id}>
                  {client.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group>
            <Form.Label>Select Site</Form.Label>
            <Form.Select
              value={selectedSite}
              onChange={(e) => setSelectedSite(e.target.value)}
              disabled={!selectedClient}
            >
              <option value="">-- Select Site --</option>
              {sites.map(site => (
                <option key={site.id} value={site.id}>
                  {site.name} ({site.city})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col>
          {loading ? (
            <Spinner animation="border" />
          ) : tasks.length === 0 ? (
            <p>No tasks found for this site.</p>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Task</th>
                  <th>Status</th>
                  <th>Assigned To</th>
                  <th>Frequency</th>
                  <th>Completed At</th>
                  <th>Job Data</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map(task => (
                  <tr key={task.id}>
                    <td>{task.id}</td>
                    <td>{task.task_name}</td>
                    <td>{task.status}</td>
                    <td>{task.assigned_to_name || task.assigned_to}</td>
                    <td>{task.frequency}</td>
                    <td>{task.completed_at || "-"}</td>
                    <td>
                        {task.data && task.data.beforePictures ? (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                            {task.data.beforePictures.map((pic, idx) => (
                                <img
                                key={idx}
                                src={`${process.env.REACT_APP_API_BASE_URL}${pic}`}
                                alt={`before-${task.id}-${idx}`}
                                style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "6px" }}
                                />
                            ))}
                            </div>
                        ) : task.data ? (
                            <pre style={{ whiteSpace: "pre-wrap", fontSize: "12px" }}>
                            {JSON.stringify(task.data, null, 2)}
                            </pre>
                        ) : (
                            "-"
                        )}
                        </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default CITasksData;
